import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Header from './components/component/Header';
import ScrollToTop from './components/component/ScrollToTop';
import LoginPage from './components/LoginPage';
import ProductListPage from './components/ProductListPage';
import ProductDetailPage from './components/ProductDetailPage';
import DischargePage from './components/DischargePage';
import AllDischargeHistoryPage from './components/AllDischargeHistoryPage';
import './index.css';

function App() {
  return (
    <div className='root'>
      <Header />
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/products" element={<ProductListPage />} />
          <Route path="/products/:order_uuid" element={<ProductDetailPage />} />
          <Route path="/discharge" element={<DischargePage />} />
          <Route path="/discharge-history" element={<AllDischargeHistoryPage />} />
        </Routes>
      </ScrollToTop>
    </div>
  );
}

export default App;
